import React, { ChangeEvent, Component } from 'react';
import { ServiceCollectionParam } from "./ServiceCollection";
import MessageProvider from "../classes/MessageProvider";
import MessageBox from "./MessageBox";

type State = {
    formOfStudy : string | undefined;
}

export default class AdminPage extends Component<ServiceCollectionParam, {}> {

    messages = new MessageProvider(this.setState.bind(this));

    username = React.createRef<HTMLInputElement>();
    tag = React.createRef<HTMLInputElement>();
    tagReview = React.createRef<HTMLInputElement>();

    state : State = {
        formOfStudy: undefined
    }

    async componentDidMount() {
        const currentUser = this.props.services.auth.getAuthCredentials().userName;
        await this.props.services.dao.getProjectResultFor(currentUser)
            .then(userResult => {
                this.setState({ formOfStudy: userResult.formOfStudy });
            });
    }


    async updateStudyForm(event: ChangeEvent<HTMLInputElement>) {
        const value = event.target.value;

        try {
            const currentUser = this.props.services.auth.getAuthCredentials().userName;
            const message = await this.props.services.dao
                .setFormOfStudy(currentUser, value);

            this.messages.success(message);

            this.setState({ formOfStudy: value });

        } catch (e) {
            this.messages.error('Error: ' + e);
        }
    }

    render() {
        return (

            <>
            <MessageBox messages={ this.messages.getMessages() } />

            <div className="row">
                <div className="col offset-3">
                    <label htmlFor="username" className="">Kasutajanimi</label>
                    <input ref={this.username} className="form-control"
                           id="username" />

                </div>
                <div className="col-1">
                    <label htmlFor="tag" className="">Tag</label>
                    <input ref={this.tag} className="form-control"
                           id="tag" />

                </div>
                <div className="col-1">
                    <br/>
                    <button
                        onClick={() => this.processUserTag()}
                        className="form-control btn-primary">Saada</button>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-1 offset-8">
                    <label htmlFor="tag2" className="">Tag</label>
                    <input ref={this.tagReview} className="form-control"
                           id="tag2" />

                </div>
                <div className="col">
                    <br/>
                    <button
                        onClick={() => this.createSampleReview()}
                        className="form-control btn-primary">Ülevaatuse näidis</button>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-5">
                    Õppevorm:&nbsp;

                    <label>
                        <input type="radio"
                               name="studyForm"
                               value="S"
                               onChange={ e => this.updateStudyForm(e) }
                               checked={ this.state.formOfStudy === 'S' } /> Statsionaar
                    </label>
                    &nbsp;
                    <label>
                        <input type="radio"
                               name="studyForm"
                               value="O"
                               onChange={ e => this.updateStudyForm(e) }
                               checked={ this.state.formOfStudy === 'O' } /> Sessioon
                    </label>
                </div>
            </div>
            </>);
    }

    private async processUserTag() {
        const username = this.username.current?.value || ''
        const tag = this.tag.current?.value || ''

        try {
            let message = await this.props.services.dao.processUserTag(username, tag);

            this.messages.success(message);
        } catch (e) {
            this.messages.error('Error: ' + e);
        }
    }

    private async createSampleReview() {
        const tag = this.tagReview.current?.value || ''

        try {
            let message = await this.props.services.dao.createSampleReview(tag);

            this.messages.success(message);
        } catch (e) {
            this.messages.error('Error: ' + e);
        }
    }
}
